import React from 'react';
import TaskRow from './TaskRow';

const TasksTableRows = ({
  canEdit,
  category,
  columns,
  email,
  items,
}) => (
  items.map((item, index) => (
    <TaskRow
      canEdit={canEdit}
      category={category}
      email={email}
      key={`tasks_table_row_${item.code}`}
      task={item}
      upward={index > 4}
      columns={columns}
    />
  ))
);

export default TasksTableRows;
